"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var DisplayHandler_1 = __importDefault(require("./___subComponents/DisplayHandler"));
var InfiniteLoader_1 = __importDefault(require("./___subComponents/InfiniteLoader"));
var ScrollRenderer_1 = __importDefault(require("./___subComponents/ScrollRenderer"));
var ScrollToTopButton_1 = __importDefault(require("./___subComponents/ScrollToTopButton"));
var uiFunctions_1 = require("./___subComponents/uiFunctions");
var isType_1 = require("./___utils/isType");
var flatListProps_1 = require("./flatListProps");
var use_list_1 = require("./hooks/use-list");
function FlatList(props) {
  var _a = __assign(__assign({}, flatListProps_1.defaultProps), props),
    list = _a.list,
    _b = _a.renderWhenEmpty,
    renderWhenEmpty = _b === void 0 ? null : _b,
    wrapperHtmlTag = _a.wrapperHtmlTag,
    renderItem = _a.renderItem,
    renderOnScroll = _a.renderOnScroll,
    // render/list related props
    _c = _a.group,
    // render/list related props
    group = _c === void 0 ? {} : _c,
    groupSeparator = _a.groupSeparator,
    // group props
    _d = _a.display,
    // group props
    display = _d === void 0 ? {} : _d,
    displayRow = _a.displayRow,
    rowGap = _a.rowGap,
    displayGrid = _a.displayGrid,
    gridGap = _a.gridGap,
    minColumnWidth = _a.minColumnWidth,
    // display props,
    hasMoreItems = _a.hasMoreItems,
    loadMoreItems = _a.loadMoreItems,
    paginationLoadingIndicator = _a.paginationLoadingIndicator,
    paginationLoadingIndicatorPosition = _a.paginationLoadingIndicatorPosition,
    scrollToTop = _a.scrollToTop,
    _e = _a.scrollToTopButton,
    scrollToTopButton = _e === void 0 ? null : _e,
    scrollToTopPadding = _a.scrollToTopPadding,
    scrollToTopOffset = _a.scrollToTopOffset,
    scrollToTopPosition = _a.scrollToTopPosition,
    _f = _a.pagination,
    pagination = _f === void 0 ? {} : _f,
    // pagination props
    // eslint-disable-next-line @typescript-eslint/naming-convention
    // @ts-ignore
    __forwarededRef = _a.__forwarededRef,
    otherProps = __rest(_a, ["list", "renderWhenEmpty", "wrapperHtmlTag", "renderItem", "renderOnScroll", "group", "groupSeparator", "display", "displayRow", "rowGap", "displayGrid", "gridGap", "minColumnWidth", "hasMoreItems", "loadMoreItems", "paginationLoadingIndicator", "paginationLoadingIndicatorPosition", "scrollToTop", "scrollToTopButton", "scrollToTopPadding", "scrollToTopOffset", "scrollToTopPosition", "pagination", "__forwarededRef"]);
  var renderList = (0, use_list_1.useList)(props);
  var tagProps = (0, react_1.useMemo)(function () {
    return Object.keys(otherProps)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .filter(function (k) {
      return flatListProps_1.defaultProps[k] === undefined;
    }).reduce(function (p, k) {
      var _a;
      return __assign(__assign({}, p), (_a = {}, _a[k] = otherProps[k], _a));
    }, {});
  }, [otherProps]);
  var renderThisItem = (0, react_1.useMemo)(function () {
    return (0, uiFunctions_1.handleRenderItem)(renderItem, (0, uiFunctions_1.handleRenderGroupSeparator)(group.separator || groupSeparator));
  }, [renderItem, group.separator, groupSeparator]);
  if (renderList.length === 0) {
    return (0, uiFunctions_1.renderBlank)(renderWhenEmpty);
  }
  var content = react_1.default.createElement(react_1.default.Fragment, null, renderOnScroll && !(loadMoreItems || pagination.loadMore) ? react_1.default.createElement(ScrollRenderer_1.default, {
    list: renderList,
    renderItem: renderItem,
    groupSeparator: group.separator || groupSeparator
  }) : renderList.map(renderThisItem), (displayRow || displayGrid || display.grid || display.row) && react_1.default.createElement(DisplayHandler_1.default, __assign({}, {
    display: display,
    displayRow: displayRow,
    rowGap: rowGap,
    displayGrid: displayGrid,
    gridGap: gridGap,
    minColumnWidth: minColumnWidth
  })), (loadMoreItems || pagination.loadMore) && !renderOnScroll && react_1.default.createElement(InfiniteLoader_1.default, {
    itemsCount: renderList.length,
    hasMore: hasMoreItems || pagination.hasMore,
    loadMore: loadMoreItems || pagination.loadMore,
    loadingIndicator: paginationLoadingIndicator || pagination.loadingIndicator,
    loadingIndicatorPosition: paginationLoadingIndicatorPosition || pagination.loadingIndicatorPosition
  }));
  var showScrollToTopButton = scrollToTop === true || scrollToTop.button || scrollToTopButton;
  var WrapperElement = "";
  if ((0, isType_1.isString)(wrapperHtmlTag) && wrapperHtmlTag || showScrollToTopButton) {
    WrapperElement = wrapperHtmlTag || "div";
  }
  return react_1.default.createElement(react_1.default.Fragment, null, WrapperElement ?
  // @ts-ignore
  react_1.default.createElement(WrapperElement, __assign({
    ref: __forwarededRef
  }, tagProps), content) : content, showScrollToTopButton && react_1.default.createElement(ScrollToTopButton_1.default, {
    button: scrollToTopButton !== null && scrollToTopButton !== void 0 ? scrollToTopButton : scrollToTop.button,
    padding: scrollToTopPadding !== null && scrollToTopPadding !== void 0 ? scrollToTopPadding : scrollToTop.padding,
    offset: scrollToTopOffset !== null && scrollToTopOffset !== void 0 ? scrollToTopOffset : scrollToTop.offset,
    position: scrollToTopPosition !== null && scrollToTopPosition !== void 0 ? scrollToTopPosition : scrollToTop.position,
    scrollingContainer: __forwarededRef
  }));
}
// export default FlatList;
exports.default = (0, react_1.forwardRef)(function (props, ref) {
  ref = ref || (0, react_1.createRef)();
  return react_1.default.createElement(FlatList, __assign({
    __forwarededRef: ref
  }, props));
});